

class Search {
    _parentEl = document.querySelector(".search");


    getQuery() {
        const query = this._parentEl.querySelector(".search__field").value;
        this._clearInput();
        return query;
    }


    addHandlerRender(handler) {
        this._parentEl.addEventListener("submit", function(event) {
            event.preventDefault();
            handler();
        });
    }


    _clearInput() {
        this._parentEl.querySelector(".search__field").value = "";
    }
}


export default new Search();